import { KpkApiProfileAuthorization } from '@keepeek/api-client';

function isAdmin(user) {
    var _a, _b;
    return (((_b = (_a = user === null || user === void 0 ? void 0 : user._embedded) === null || _a === void 0 ? void 0 : _a.profile.authorizations) === null || _b === void 0 ? void 0 : _b.some(function (auth) { return auth === KpkApiProfileAuthorization.Administrator; })) || false);
}
function isTechAdmin(user) {
    var _a, _b;
    return (((_b = (_a = user === null || user === void 0 ? void 0 : user._embedded) === null || _a === void 0 ? void 0 : _a.profile.authorizations) === null || _b === void 0 ? void 0 : _b.some(function (auth) { return auth === KpkApiProfileAuthorization.TechAdministrator; })) || false);
}

export { isAdmin, isTechAdmin };
//# sourceMappingURL=utils.js.map
